export default {
  interface: {
    funding: {
      round: 'ラウンド',
      funding_amount: '調達額',
      valuation: '評価額',
      lead_investor: 'リード投資家',
    },
    image: '画像',
    show_more: 'もっと見る',
    max_20_chars: '最大20文字',
    max_400_chars: '最大400文字',
    ai_inspiration_hub: 'AIインスピレーションハブ',
    weekly_pick: '週間セレクト',
    loading_data: 'データを読み込み中…',
    dateNav: {
      year: '年',
      month: '月',
      allTime: 'すべての期間',
      jump: '年月',
      collapse: '閉じる',
      day: '日',
      selectDay: '日を選択',
      allDays: 'すべての日程',
      weekRange: '{sm}{sd}日 - {em}{ed}日',
      dayFormat: '{day}日',
    },
    months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
    share: {
      card_button: 'シェア',
      title: 'シェアカード',
      sharer: 'シェアする人',
      sharerPlaceholder: 'お名前（任意）',
      message: 'メッセージ',
      messagePlaceholder: 'この製品についてのご意見（任意）',
      generate: 'カードを生成',
      generating: '生成中...',
      cancel: 'キャンセル'
    },
    nav: {
      home: 'AI製品',
      funding: 'AI資金調達',
    },
    pageTitle: {
      home: 'AI製品 - AIインスピレーションハブ',
      tag: '{tag} 関連製品 - AIインスピレーションハブ',
    },
    title: {
      home: 'AIインスピレーションハブ',
      funding: 'AI資金調達の最新情報',
      search: '検索："{query}"',
      tag: '{tag} 関連製品',
      exportChannels: 'グローバル展開チャネル',
      tools: '便利なツール'
    },
    search: {
      placeholder: 'AI製品を検索...',
      button: '検索',
      noResults: {
        title: '申し訳ありません。結果が見つかりませんでした',
        suggestion: '別のキーワードで検索してください'
      }
    },
    product: {
      visit_website: '{name}のウェブサイトを訪問',
      logo_alt: '{name}のロゴ',
      preview_image: '{name}の製品プレビュー画像 {index}/{total}',
      preview_image_full: '{name}の製品プレビュー画像（フルサイズ） {index}/{total}',
      view_more_tag: '{tag}に関連する製品をもっと見る'
    }
  },
  channel: {
    scale: '規模'
  },
  meta: {
    description: 'AIインスピレーションハブは、最新かつ包括的なAI製品とツールを提供し、製品のインスピレーションとワークフローツールを見つけるお手伝いをします',
    tagDescription: '{tag}に関連するAI製品とツールを探索し、革新的なソリューションを発見',
    keywords: {
      home: 'AIインスピレーションハブ, AIツール, AI製品, AIアプリ, AIリソース, 人工知能ツール, AI開発, クリエイティブツール, ワークフロー最適化, スタートアップ, 個人開発',
      tag: '{tag}, AIツール, AI製品, AIアプリ, AIリソース, 人工知能, 革新的ツール, インテリジェントアプリケーション'
    }
  }
}
